import { getAxiosInstance } from "../utils/apiClient";

const axiosInstance = getAxiosInstance();

/**
 * Отримує список всіх активних категорій
 * @returns {Promise<{success: boolean, data: Array<{_id: string, name: string, description: string}>, count: number}>}
 */
export const getCategoriesAPI = () => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/api/categories", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.error("getCategoriesAPI error:", err);
        reject(err?.response?.data || err);
      });
  });
};

